import { z } from "zod";

export const createEventFormAnswersSchema = z.object({
  eventId: z.string().min(1),
  answers: z
    .array(
      z.object({
        questionId: z.string().min(1),
        answer: z.string().optional(),
        answerList: z.array(z.string()),
      })
    )
    .superRefine((answers, ctx) => {
      answers.forEach((answer, index) => {
        const hasAnswer = answer.answer && answer.answer.trim().length > 0;
        const hasAnswerList = answer.answerList && answer.answerList.length > 0;

        if (!hasAnswer && !hasAnswerList) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Cette réponse est requise",
            path: [index, "answer"],
          });
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Veuillez sélectionner au moins une option",
            path: [index, "answerList"],
          });
        }
      });
    }),
  wantsToAppearInRegisteredList: z.boolean().optional(),
  wantsExhibitorContact: z.boolean().optional(),
});

export type CreateEventFormAnswersForm = z.infer<
  typeof createEventFormAnswersSchema
>;

export const defaultCreateEventFormAnswersValues: CreateEventFormAnswersForm = {
  answers: [],
  eventId: "",
};
